import * as React from "react";
import { LineItem, LineItemMedia, LineItemContent } from "@grandvisionhq/common";
import { Heading, Text } from "@grandvisionhq/elements";
import { RemoveLineItemContainer } from "../../../../containers/modules/LineItems/containers/RemoveLineItemContainer.js";
import { PricesContainer } from "../../../../containers/modules/LineItems/containers/PricesContainer.js";
const UnavailableLineItem = ({ lineItem, lineItemMediaIcon }) => {
  const { imageUrl, isGift, price, productUrl, name, subtitle, imageAlt } = lineItem;
  return /* @__PURE__ */ React.createElement(LineItem, { className: "line-item line-item--unavailable-line-item" }, /* @__PURE__ */ React.createElement("div", { className: "line-item__media" }, lineItemMediaIcon && /* @__PURE__ */ React.createElement(LineItemMedia, { type: "icon", ...lineItemMediaIcon }), /* @__PURE__ */ React.createElement(
    LineItemMedia,
    {
      className: "line-item__image",
      type: "image",
      href: productUrl,
      imageUrl,
      imageAlt
    }
  )), /* @__PURE__ */ React.createElement(LineItemContent, { className: "line-item__content" }, /* @__PURE__ */ React.createElement("div", { className: "line-item__description" }, /* @__PURE__ */ React.createElement(Heading, { variant: "smallest", component: "h2", className: "line-item__title" }, name), subtitle && /* @__PURE__ */ React.createElement(Text, { component: "span", variant: "body" }, subtitle)), /* @__PURE__ */ React.createElement("div", { className: "line-item__quantity-and-price" }, !isGift && /* @__PURE__ */ React.createElement("div", { className: "line-item__quantity" }, /* @__PURE__ */ React.createElement("div", { className: "line-item__quantity-selector" }, /* @__PURE__ */ React.createElement("div", { className: "line-item__delete-btn" }, /* @__PURE__ */ React.createElement(RemoveLineItemContainer, { lineItem })))), /* @__PURE__ */ React.createElement(
    PricesContainer,
    {
      discount: price.total.discount,
      originalPrice: price.total.original,
      totalPrice: price.total.gross
    }
  ))));
};
export {
  UnavailableLineItem
};
//# sourceMappingURL=UnavailableLineItem.js.map
